var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn_box"},[_c('a',{staticClass:"btn btn__recibir--info",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.showFormRecibirInfo($event)}}},[_vm._v("recibir información")])])}
var staticRenderFns = []

export { render, staticRenderFns }